import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { useScrollReveal } from "../../hooks/useScrollReveal";

function Home() {
  useScrollReveal();

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center">
            <Col md={7} className="home-header">
              <p className="reveal" style={{ color: "rgba(232,224,240,0.5)", fontSize: "1em", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "0.5rem" }}>
                Welcome to my portfolio
              </p>
              <h1 className="reveal reveal-delay-1 heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-label="wave">👋🏻</span>
              </h1>
              <h1 className="reveal reveal-delay-2 heading-name">
                I'M{" "}
                <strong className="main-name">Mohamed Marwen</strong>
              </h1>
              <div className="reveal reveal-delay-3" style={{ padding: "30px 0", textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} className="reveal reveal-delay-2" style={{ paddingBottom: 10, marginTop: 20, textAlign: "center" }}>
              <img
                src={homeLogo}
                alt="home illustration"
                className="img-fluid"
                style={{ maxHeight: "420px", filter: "drop-shadow(0 0 40px rgba(180,79,255,0.3))" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;